import React from 'react';
import {
  ArrowCircleUp,
  BarChart,
  CallMerge,
  ChangeCircle,
  Cached,
  FindReplace,
  Logout,
  Shield,
  ShowChart,
  ImageAspectRatio,
  GroupWork,
  InsertChart,
  Insights,
  Language,
  LineStyle,
  LibraryBooks,
  LegendToggle,
  LensBlur,
  LeakAdd,
  Mediation,
  Moving,
  MultilineChart,
  Nat,
  NetworkCheck,
  Outbound,
  OnlinePrediction,
  OpenWith,
  Public,
  Radar,
  Reddit,
  RadioButtonChecked,
  SavedSearch,
  SettingsInputAntenna,
  SettingsBackupRestore,
  SyncAlt,
  SwapHoriz,
  WaterfallChart,
  Workspaces,
  Widgets,
  DeviceHub,
  Grain,
  QueryStats,
  Stream,
  AttachMoney,
  AccountBalance,
  AddShoppingCart,
  Remove,
  LocalGasStation,
} from '@mui/icons-material';

const UnifiedDashboardIcon = () => (
  <span
    style={{
      display: 'inline-flex',
      width: 14,
      height: 14,
      alignItems: 'center',
      justifyContent: 'center',
      color: 'var(--search-icon-color, #1e3354)',
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={14} height={14} fill="currentColor">
      <path d="M4 9h4v11H4zm12 4h4v7h-4zm-6-9h4v16h-4z" />
    </svg>
  </span>
);

export const iconsMap: { [key: string]: any } = {
  ArrowCircleUp: <ArrowCircleUp />,
  BarChart: <BarChart />,
  CallMerge: <CallMerge />,
  ChangeCircle: <ChangeCircle />,
  Cached: <Cached />,
  FindReplace: <FindReplace />,
  Logout: <Logout />,
  Shield: <Shield />,
  ShowChart: <ShowChart />,
  ImageAspectRatio: <ImageAspectRatio />,
  GroupWork: <GroupWork />,
  InsertChart: <InsertChart />,
  Insights: <Insights />,
  Language: <Language />,
  LineStyle: <LineStyle />,
  LibraryBooks: <LibraryBooks />,
  LegendToggle: <LegendToggle />,
  LensBlur: <LensBlur />,
  LeakAdd: <LeakAdd />,
  Mediation: <Mediation />,
  Moving: <Moving />,
  MultilineChart: <MultilineChart />,
  Nat: <Nat />,
  NetworkCheck: <NetworkCheck />,
  Outbound: <Outbound />,
  OnlinePrediction: <OnlinePrediction />,
  OpenWith: <OpenWith />,
  Public: <Public />,
  Radar: <Radar />,
  Reddit: <Reddit />,
  RadioButtonChecked: <RadioButtonChecked />,
  SavedSearch: <SavedSearch />,
  SettingsInputAntenna: <SettingsInputAntenna />,
  SettingsBackupRestore: <SettingsBackupRestore />,
  SyncAlt: <SyncAlt />,
  SwapHoriz: <SwapHoriz />,
  WaterfallChart: <WaterfallChart />,
  Workspaces: <Workspaces />,
  Widgets: <Widgets />,
  DeviceHub: <DeviceHub />,
  Grain: <Grain />,
  QueryStats: <QueryStats />,
  Stream: <Stream />,
  AttachMoney: <AttachMoney />,
  AccountBalance: <AccountBalance />,
  AddShoppingCart: <AddShoppingCart />,
  Remove: <Remove />,
  LocalGasStation: <LocalGasStation />,
  UnifiedDashboard: <UnifiedDashboardIcon />,
};
